import axios from "axios";
import { API, AppConfig, axiosInstance, gpsInstance, newgpsInstance } from "lib";

export const getAllVehicleGPS = (data = {}) => {
  return gpsInstance
    .post(API.GET_ALL_VEHICLE_FOR_GPS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getTmsVehicleCounts = (data = {}) => {
  return axiosInstance
    .post(API.GET_TMS_VEHICLE_COUNT, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getGpsStatusCounts = (data = {}) => {
  return gpsInstance
    .post(API.GET_GPS_STATUS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getGpsTimeline = (data = {}) => {
  return newgpsInstance
    .post(API.GPSTIMELINE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getSummaryGps = (data = {}) => {
  return newgpsInstance
    .post(API.GPS_SUMMARY, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getStoppageGps = (data = {}) => {
  return newgpsInstance
    .post(API.GPS_STOPPAGE,data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getGpsVehicle = (data = {}) => {
  return axiosInstance
    .post(API.GET_GPS_VEHICLE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

// GPS Module

export const getTimeLineGPSData = (data = {}, query = {}) => {
  return newgpsInstance
    .post(API.GPS_TIME_LINE_DATA + `?page=${query?.offset ? query?.offset : ''}&limit=${query?.limit ? query?.limit : ''}` ,data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};


export const gpsSummaryList = (data = {}) => {
  return newgpsInstance
    .post(API.TRIP_GPS_SUMMARY, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const gpsParkedList = (data = {}) => {
  return newgpsInstance
    .post(API.TRIP_GPS_PARKED, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const gpsRunningList = (data = {}) => {
  return newgpsInstance
    .post(API.TRIP_GPS_RUNNING, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getTimeLineGPSList = (data = {}, query = {}) => {
  return newgpsInstance
    .post(API.GPS_TIMELINE + `?page=${query?.offset ? query?.offset : ''}&limit=${query?.limit ? query?.limit : ''}` ,data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};